import { RoleTypePermission } from '@carm/_core';
import { Permission } from '@carm/_core/role-type-permissions/models/role-type-permissions.model';
import { Action, createReducer, on } from '@ngrx/store';
import * as RoleTypePermissionActions from '../actions/role-type-permission.actions';

export const carmPermissionsKey = 'carm-permissions';

export interface RoleTypePermissionState {
  roleTypePermissions: RoleTypePermission[];
  permissions: Permission[];
  nativePermissions: Permission[];
  loading: boolean;
  success: boolean;
  error: any;
}

export const initialState: RoleTypePermissionState = {
  roleTypePermissions: [],
  permissions: [],
  nativePermissions: [],
  loading: false,
  success: false,
  error: null,
};

const Reducer = createReducer(
  initialState,
  on(RoleTypePermissionActions.loadPermissions, (state) => ({...state, loading: true, success: false})),
  on(RoleTypePermissionActions.loadPermissionsSuccess, (state, {data}) => {
        return data ? { ...state, permissions: data, loading: false, success: true} : {...state,loading: false, success: true};
   }),
  on(RoleTypePermissionActions.loadPermissionsFailure, (state, { error }) => ({...state, error, loading: false, success: false})),
  on(RoleTypePermissionActions.loadNativeBusinessPermissions, (state) => ({...state, loading: true, success: false})),
  on(RoleTypePermissionActions.loadNativeBusinessPermissionsSuccess, (state, {data}) => {
        return data ? { ...state, nativePermissions: data, loading: false, success: true} : {...state,loading: false, success: true};
   }),
  on(RoleTypePermissionActions.loadNativeBusinessPermissionsFailure, (state, { error }) => ({...state, error, loading: false, success: false})),
  on(RoleTypePermissionActions.loadRoleTypePermissions, (state) => ({...state, loading: true, success: false})),
  on(RoleTypePermissionActions.loadRoleTypePermissionsSuccess, (state, {data}) => {
        return data ? { ...state, roleTypePermissions: [...state.roleTypePermissions, data ], loading: false, success: true} : {...state,loading: false, success: true};
   }),
   on(RoleTypePermissionActions.loadRoleTypePermissionsFailure, (state, { error }) => ({...state, error, loading: false, success: false})),
   on(RoleTypePermissionActions.clearPermissions, (state) => ({...initialState})),
);

export function roleTypePermissionReducer(state: RoleTypePermissionState | undefined, action: Action) {
  return Reducer(state, action);
}
